/**
 * @generated SignedSource<<2b3f60b3fc675e58a41d17fd76c5f762>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminPanelRefetchQuery$variables = {
  id: string;
};
export type AdminPanelRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"PingPongContainer_pingPong">;
  } | null;
};
export type AdminPanelRefetchQuery = {
  variables: AdminPanelRefetchQuery$variables;
  response: AdminPanelRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminPanelRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PingPongContainer_pingPong"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminPanelRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "counter",
                "storageKey": null
              }
            ],
            "type": "PingPongCounter",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aca5f0be7b9c8d22ca0ab47a019c4e32",
    "id": null,
    "metadata": {},
    "name": "AdminPanelRefetchQuery",
    "operationKind": "query",
    "text": "query AdminPanelRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...PingPongContainer_pingPong\n    id\n  }\n}\n\nfragment PingPongContainer_pingPong on PingPongCounter {\n  id\n  counter\n}\n"
  }
};
})();

(node as any).hash = "3fd70820d3f457c54ecfca85d4bb06a3";

export default node;
